// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table-emptyImg .empty[data-v-54897251] {\n  width: 150px;\n  height: 150px;\n  margin-top: 80px;\n  margin-bottom: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
